import React from 'react';
import { Home, Package, Bell, User } from 'lucide-react';
interface BottomNavProps {
  onNetworkClick?: () => void;
  onInventoryClick?: () => void;
  onRMIClick?: () => void;
  onNotificationsClick?: () => void;
  onProfileClick?: () => void;
  activeNav?: 'rmi' | 'inventory' | 'network' | 'notifications' | 'profile' | null;
}
export function BottomNav({
  onNetworkClick,
  onInventoryClick,
  onRMIClick,
  onNotificationsClick,
  onProfileClick,
  activeNav = null
}: BottomNavProps) {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 safe-bottom z-50 w-full" data-id="element-24">
      <div className="w-full mx-auto px-2 pt-2 pb-1" data-id="element-25">
        <div className="flex justify-between items-end relative" data-id="element-26">
          {/* Left Group */}
          <div className="flex-1 flex justify-around" data-id="element-27">
            <button onClick={onRMIClick} className="flex flex-col items-center gap-1 relative py-1" data-id="element-28">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-colors ${activeNav === 'rmi' ? 'bg-primary text-accent' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-29">
                <Home className="w-6 h-6" strokeWidth={1.5} data-id="element-30" />
              </div>
              <span className={`text-[10px] font-medium ${activeNav === 'rmi' ? 'text-primary' : 'text-gray-400'}`} data-id="element-31">
                RMI
              </span>
              <span className="absolute top-0 right-1 w-2 h-2 bg-red-500 rounded-full border border-white" data-id="element-32"></span>
            </button>

            <button onClick={onInventoryClick} className="flex flex-col items-center gap-1 relative py-1" data-id="element-33">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-colors ${activeNav === 'inventory' ? 'bg-primary text-accent' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-34">
                <Package className="w-6 h-6" strokeWidth={1.5} data-id="element-35" />
              </div>
              <span className={`text-[10px] font-medium ${activeNav === 'inventory' ? 'text-primary' : 'text-gray-400'}`} data-id="element-36">
                Inventory
              </span>
              <span className="absolute top-0 right-2 w-2 h-2 bg-red-500 rounded-full border border-white" data-id="element-37"></span>
            </button>
          </div>

          {/* Center FAB Container */}
          <div className="relative -top-6 mx-2" data-id="element-38">
            <button onClick={onNetworkClick} className="w-14 h-14 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg shadow-primary/30 text-white transform transition-transform active:scale-95" data-id="element-39">
              <img src="https://cdn.magicpatterns.com/uploads/ompKNW2ZKiat5oXcKrq3mX/white_logo_.svg" alt="Network" className="w-7 h-7" data-id="element-40" />
            </button>
            <div className="text-center mt-1" data-id="element-41">
              <span className={`text-[10px] font-medium ${activeNav === 'network' ? 'text-primary' : 'text-neutral-text'}`} data-id="element-42">
                Network
              </span>
            </div>
          </div>

          {/* Right Group */}
          <div className="flex-1 flex justify-around" data-id="element-43">
            <button onClick={onNotificationsClick} className="flex flex-col items-center gap-1 relative py-1" data-id="element-44">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-colors ${activeNav === 'notifications' ? 'bg-primary text-accent' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-45">
                <Bell className="w-6 h-6" strokeWidth={1.5} data-id="element-46" />
              </div>
              <span className={`text-[10px] font-medium ${activeNav === 'notifications' ? 'text-primary' : 'text-gray-400'}`} data-id="element-47">
                Notifications
              </span>
              <span className="absolute top-0 right-3 w-2 h-2 bg-red-500 rounded-full border border-white" data-id="element-48"></span>
            </button>

            <button onClick={onProfileClick} className="flex flex-col items-center gap-1 py-1" data-id="element-49">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-colors ${activeNav === 'profile' ? 'bg-primary text-accent' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-50">
                <User className="w-6 h-6" strokeWidth={1.5} data-id="element-51" />
              </div>
              <span className={`text-[10px] font-medium ${activeNav === 'profile' ? 'text-primary' : 'text-gray-400'}`} data-id="element-52">
                Profile
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>;
}